var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        [
          _c(
            "el-button",
            { attrs: { slot: "trigger", type: "primary" }, slot: "trigger" },
            [_vm._v(_vm._s(_vm.$t("SeaExport.PTImport")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }